import React, { useContext } from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton/TextButton';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import WidgetBoxWrapper from './_partials/WidgetBoxWrapper/WidgetBoxWrapper';
import useGruser from '../../hooks/useGruser';
import useModule from '../../hooks/useModule';
import usePage from '../../hooks/usePage';
import WidgetHeaderMobile from './lego/WidgetHeaderMobile/WidgetHeaderMobile';
import WidgetHeader from './lego/WidgetHeader/WidgetHeader';
import { BiData, BiContextProvidedValue } from '@wix/da-bi/pkg/events';
import WidgetEditControls from './_partials/WidgetEditControls/WidgetEditControls';
import s from './WidgetBox.scss';
const WidgetBox = ({ moduleId, header, className, headerClassName, dataHook, children, headerExtras, count, seeAllUrl, direction, configPopoverComponent, confirmRemove })=>{
    const { gruser } = useGruser();
    const gruserPage = usePage();
    const isMobile = useContext(MobileContext);
    const module = useModule(moduleId);
    const { t } = useTranslation();
    if (!gruser || !module) {
        return null;
    }
    const moduleData = module.moduleData;
    const renderHeaderContents = ()=>{
        if (!seeAllUrl) {
            return header;
        }
        return /*#__PURE__*/ React.createElement(BiLink, {
            biData: BiData({
                evid: 106,
                creatorid: BiContextProvidedValue,
                typeid: BiContextProvidedValue,
                itemid: BiContextProvidedValue,
                sectionname: BiContextProvidedValue
            }),
            href: seeAllUrl
        }, header);
    };
    const renderRightSideSeeAllLink = ()=>{
        if (!moduleData['hasMore']) {
            return null;
        }
        return /*#__PURE__*/ React.createElement(TextButton, {
            size: "medium",
            variant: "main",
            biData: BiData({
                evid: 106,
                typeid: BiContextProvidedValue,
                itemid: BiContextProvidedValue,
                creatorid: BiContextProvidedValue,
                sectionname: BiContextProvidedValue
            }),
            href: seeAllUrl,
            className: s['see-all'],
            "data-role": "see-all-link"
        }, t('gruser.widgetbox.button.seeAll'));
    };
    const renderHeaderExtraElements = ()=>{
        return /*#__PURE__*/ React.createElement("div", {
            className: s['header-extras']
        }, headerExtras, /*#__PURE__*/ React.createElement(WidgetEditControls, {
            moduleId: moduleId,
            direction: direction,
            configPopoverComponent: configPopoverComponent,
            confirmRemove: confirmRemove
        }), renderRightSideSeeAllLink());
    };
    return /*#__PURE__*/ React.createElement(BiLoggerContextProvider, {
        value: {
            widgetname: module.name,
            widgetzone: module.zonename,
            sectionname: (gruserPage === null || gruserPage === void 0 ? void 0 : gruserPage.name) === 'deviation' ? 'deviation_widget' : undefined
        }
    }, /*#__PURE__*/ React.createElement(WidgetBoxWrapper, {
        "data-role": "widget",
        className: c(s['root'], className),
        "data-hook": dataHook,
        "data-moduleid": moduleId,
        "data-userid": gruser.gruserId,
        id: `module-${moduleId}`
    }, isMobile ? /*#__PURE__*/ React.createElement(WidgetHeaderMobile, {
        rootClassName: headerClassName,
        header: renderHeaderContents(),
        count: count,
        isSticky: false,
        extras: renderHeaderExtraElements()
    }) : /*#__PURE__*/ React.createElement(WidgetHeader, {
        className: headerClassName,
        header: renderHeaderContents(),
        count: count,
        extras: renderHeaderExtraElements()
    }), children));
};
WidgetBox.displayName = 'WidgetBox';
export default WidgetBox;
